module.exports = __webpack_public_path__ + "img/Technischer_Zug_mit_FGr_Wasserschaden_Pumpen.bba2f4ed.svg";